// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PackageCredits_wrapper__2Ljqo","terms":"PackageCredits_terms__3GfU4","paypalImg":"PackageCredits_paypalImg__3yzoq","disabled":"PackageCredits_disabled__3WEQr"};